import React               from "react";

import Button              from 'react-bootstrap/Button';
import Modal               from 'react-bootstrap/Modal';

const WarningModal = (props) => {
  const {
    show,
    children,
    onClickOk
  } = props

  return (
    <Modal show={show} onHide={onClickOk}>
      <Modal.Body>
        {children}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={onClickOk}>
          Ok
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default WarningModal;